module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-分享方式-微博.6ee57.png";